import React from 'react';
import {h, Component } from "preact";

export default class Writing extends Component {
    render() {
        return (
            <div className="writing">
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/app/Writing.js